import { css } from 'styled-components';
import PropTypes from 'prop-types';
var Display = css(["", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref) {
  var display = _ref.display;
  return display && css(["display:", ";"], display);
}, function (_ref2) {
  var justifyContent = _ref2['justify-content'];
  return justifyContent && css(["justify-content:", ";"], justifyContent);
}, function (_ref3) {
  var alignItems = _ref3['align-items'];
  return alignItems && css(["align-items:", ";"], alignItems);
}, function (_ref4) {
  var flexWrap = _ref4['flex-wrap'];
  return flexWrap && css(["flex-wrap:", ";"], flexWrap);
}, function (_ref5) {
  var flexDirection = _ref5['flex-direction'];
  return flexDirection && css(["flex-direction:", ";"], flexDirection);
}, function (_ref6) {
  var theme = _ref6.theme,
    displayXs = _ref6['display-xs'],
    justifyContentXs = _ref6['justify-content-xs'],
    alignItemsXs = _ref6['align-items-xs'],
    flexDirectionXs = _ref6['flex-direction-xs'],
    flexWrapXs = _ref6['flex-wrap-xs'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", "}"], theme.breakpoint.xs, displayXs && css(["display:", ";"], displayXs), justifyContentXs && css(["justify-content:", ";"], justifyContentXs), alignItemsXs && css(["align-items:", ";"], alignItemsXs), flexWrapXs && css(["flex-wrap:", ";"], flexWrapXs), flexDirectionXs && css(["flex-direction:", ";"], flexDirectionXs));
}, function (_ref7) {
  var theme = _ref7.theme,
    displaySm = _ref7['display-sm'],
    justifyContentSm = _ref7['justify-content-sm'],
    alignItemsSm = _ref7['align-items-sm'],
    flexDirectionSm = _ref7['flex-direction-sm'],
    flexWrapSm = _ref7['flex-wrap-sm'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", "}"], theme.breakpoint.sm, displaySm && css(["display:", ";"], displaySm), justifyContentSm && css(["justify-content:", ";"], justifyContentSm), alignItemsSm && css(["align-items:", ";"], alignItemsSm), flexWrapSm && css(["flex-wrap:", ";"], flexWrapSm), flexDirectionSm && css(["flex-direction:", ";"], flexDirectionSm));
}, function (_ref8) {
  var theme = _ref8.theme,
    displayMd = _ref8['display-md'],
    justifyContentMd = _ref8['justify-content-md'],
    alignItemsMd = _ref8['align-items-md'],
    flexDirectionMd = _ref8['flex-direction-md'],
    flexWrapMd = _ref8['flex-wrap-md'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", "}"], theme.breakpoint.md, displayMd && css(["display:", ";"], displayMd), justifyContentMd && css(["justify-content:", ";"], justifyContentMd), alignItemsMd && css(["align-items:", ";"], alignItemsMd), flexWrapMd && css(["flex-wrap:", ";"], flexWrapMd), flexDirectionMd && css(["flex-direction:", ";"], flexDirectionMd));
}, function (_ref9) {
  var theme = _ref9.theme,
    displayLg = _ref9['display-lg'],
    justifyContentLg = _ref9['justify-content-lg'],
    alignItemsLg = _ref9['align-items-lg'],
    flexDirectionLg = _ref9['flex-direction-lg'],
    flexWrapLg = _ref9['flex-wrap-lg'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", "}"], theme.breakpoint.lg, displayLg && css(["display:", ";"], displayLg), justifyContentLg && css(["justify-content:", ";"], justifyContentLg), alignItemsLg && css(["align-items:", ";"], alignItemsLg), flexWrapLg && css(["flex-wrap:", ";"], flexWrapLg), flexDirectionLg && css(["flex-direction:", ";"], flexDirectionLg));
});
var displayTypes = ['inline', 'block', 'contents', 'flex', 'grid', 'inline-block', 'inline-flex', 'inline-grid', 'inline-table', 'list-item', 'table', 'table-caption', 'table-column-group', 'table-header-group', 'table-footer-group', 'table-row-group', 'table-cell', 'table-column', 'table-row', 'none', 'initial', 'inherit'];
var justifyTypes = ['start', 'end', 'flex-start', 'flex-end', 'center', 'left', 'right', 'normal', 'baseline', 'space-between', 'space-around', 'space-evenly', 'stretch', 'safe', 'unsafe'];
var alignTypes = ['normal', 'flex-start', 'flex-end', 'center', 'start', 'end', 'self-start', 'self-end', 'stretch', 'safe', 'unsafe'];
var flexWrapTypes = ['nowrap', 'wrap', 'wrap-reverse'];
var flexDirectionType = ['row', 'row-reverse', 'column', 'column-reverse'];
var DisplayPropTypes = {
  display: PropTypes.oneOf(displayTypes),
  'justify-content': PropTypes.oneOf(justifyTypes),
  'align-items': PropTypes.oneOf(alignTypes),
  'flex-wrap': PropTypes.oneOf(flexWrapTypes),
  'flex-direction': PropTypes.oneOf(flexDirectionType),
  'display-xs': PropTypes.oneOf(displayTypes),
  'justify-content-xs': PropTypes.oneOf(justifyTypes),
  'align-items-xs': PropTypes.oneOf(alignTypes),
  'flex-wrap-xs': PropTypes.oneOf(flexWrapTypes),
  'flex-direction-xs': PropTypes.oneOf(flexDirectionType),
  'display-sm': PropTypes.oneOf(displayTypes),
  'justify-content-sm': PropTypes.oneOf(justifyTypes),
  'align-items-sm': PropTypes.oneOf(alignTypes),
  'flex-wrap-sm': PropTypes.oneOf(flexWrapTypes),
  'flex-direction-sm': PropTypes.oneOf(flexDirectionType),
  'display-md': PropTypes.oneOf(displayTypes),
  'justify-content-md': PropTypes.oneOf(justifyTypes),
  'align-items-md': PropTypes.oneOf(alignTypes),
  'flex-wrap-md': PropTypes.oneOf(flexWrapTypes),
  'flex-direction-md': PropTypes.oneOf(flexDirectionType),
  'display-lg': PropTypes.oneOf(displayTypes),
  'justify-content-lg': PropTypes.oneOf(justifyTypes),
  'align-items-lg': PropTypes.oneOf(alignTypes),
  'flex-wrap-lg': PropTypes.oneOf(flexWrapTypes),
  'flex-direction-lg': PropTypes.oneOf(flexDirectionType)
};
export { Display, DisplayPropTypes };